import { render, staticRenderFns } from "./addHotel.vue?vue&type=template&id=8a796ece&"
import script from "./addHotel.vue?vue&type=script&lang=js&"
export * from "./addHotel.vue?vue&type=script&lang=js&"
import style0 from "./addHotel.vue?vue&type=style&index=0&id=8a796ece&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports